var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Loader from "../../components/loader";
import "./style.scss";
/**
 * component to render a table based on the rows and columns provided in props
 */
export var Table = function (props) {
    var columns = props.columns, cells = props.cells, rows = props.rows, fallbackComponent = props.fallbackComponent, isLoading = props.isLoading, classes = props.classes;
    return (_jsxs(_Fragment, { children: [rows.length > 0 && !isLoading ? (_jsx("table", __assign({ className: "".concat(classes, " table-layout"), "data-testid": "generic-table" }, { children: _jsxs("tbody", { children: [_jsx("tr", { children: columns.length > 0 &&
                                columns.map(function (_a, idx) {
                                    var title = _a.title, width = _a.width;
                                    return (_jsx("th", __assign({ style: { width: width } }, { children: title }), idx));
                                }) }), rows.map(function (rowItem, rowId) { return (_jsx("tr", { children: columns.map(function (_a, idx) {
                                var id = _a.id;
                                var cellValue = cells[id](rowItem);
                                return (_jsx("td", __assign({ className: "word-wrap" }, { children: cellValue }), idx));
                            }) }, rowId)); })] }) }))) : rows.length <= 0 && !isLoading ? (fallbackComponent) : null, isLoading && _jsx(Loader, { classes: "spinner-layout" })] }));
};
Table.defaultProps = {
    classes: "",
    columns: [],
    rows: [],
    cells: {},
    fallbackComponent: _jsx(_Fragment, {}),
    isLoading: false,
};
